<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'LicensesPage',
  components: {},
  data() {
    return {}
  },
  methods: {
    
  }
}
</script>

<style scoped>

</style>
